import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, from, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { ApiService } from '@core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private api: ApiService) {}

//   createFilesUploadReq(
//     id: number,
//     torzs: string,
//     files: any
//   ): Observable<any> {
//     const reqs = [];

//     if (files.new?.length || files.removed?.length) {
//       reqs.push({
//         endpoint: environment.filesApi,
//         fajlok: files.new,
//         torolni: files.removed,
//       });
//     }

//     if (reqs.length) {
//       return from(reqs).pipe(
//         mergeMap(({ endpoint, fajlok, torolni }) =>
//           this.api.uploadFiles(endpoint, fajlok, torolni, torzs, id)
//         )
//       );
//     } else {
//       return of(true);
//     }
//   }

  filterUploadsByTorzs(data: any, torzs: string): any {
    if (!data) {
      return data;
    }

    // Van file
    if (data?.fajlok?.length > 0) {
      return {
        ...data,
        dokumentumok: {
          new: [],
          removed: [],
          uploads: data.fajlok.filter((e: any) => e.modul === torzs),
        },
      };
    }
    // Nincs file
    else {
      return data;
    }
  }

  uploadFiles(
    newUploads: File[],
    fileNames: any[],
    torzs: string,
    partnerId: number
  ): Observable<any> {
    if (!newUploads) {
      return of(null);
    } else {
      const formData: FormData = this.createFilesFormData(newUploads, fileNames);

      return this.api
        .post(
          `${environment.fileUpload}/${torzs}/${partnerId}`,
          formData
        )
        .pipe(catchError(() => of(null)));
    }
  }

  deleteFile(
    torzs: string,
    partnerId: number,
    fileId: any
  ): Observable<any> {
      return this.api
        .post(
          `${environment.fileUpload}/${torzs}/${partnerId}`,
          {
            torolni: fileId,
          },
          "Sikeres törlés"
        )
        .pipe(catchError(() => of(null)));
  }

  private createFilesFormData(newUploads: File[], fileNames: string[]): FormData {
    const formData: FormData = new FormData();

    if (newUploads) {
      newUploads.forEach((file: File, index: number) => {
        const kiterjesztes = file.name.split('.').pop();
        formData.append(`${index}`, file, `${fileNames[index]}.${kiterjesztes}`);
      });
    }

    return formData;
  }

  private createDeleteFormData(torolni: string) {
    const formData: FormData = new FormData();

    if (torolni) {
      formData.append('torolni', torolni);
    }

    return formData;
  }

}
